import { render, staticRenderFns } from "./playerlist.vue?vue&type=template&id=2070ac4e&scoped=true&"
import script from "./playerlist.vue?vue&type=script&lang=js&"
export * from "./playerlist.vue?vue&type=script&lang=js&"
import style0 from "./playerlist.vue?vue&type=style&index=0&id=2070ac4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2070ac4e",
  null
  
)

export default component.exports